import React, { useRef } from "react";
import RippleButton from "../buttons/RippleButton";
import FlagWave from "./FlagWave";

const FlagCard = ({ item, idx, completed, handleGuess }) => {
  const parentRef = useRef();

  return (
    <RippleButton
      className={`transition-color w-full cursor-pointer items-start justify-center overflow-hidden border-2 border-slate-300 bg-slate-200 px-2 py-1 text-left font-bold dark:border-slate-400  dark:bg-slate-600 ${
        [
          " !dark:bg-majky-700 !dark:border-majky-500  !border-majky-700  !bg-majky-700 !text-slate-100 ",
          " !dark:bg-red-600 !dark:border-red-400  !border-red-600  !bg-red-600 !text-slate-100 ",
          " !dark:bg-blue-600 !dark:border-blue-400  !border-blue-600  !bg-blue-600 !text-slate-100 ",
        ][item.mode]
      } rounded-md hover:bg-majky-400 hover:text-white active:text-white ${
        (completed || item.mode !== -1) && " pointer-events-none "
      } select-none`}
      onClick={() => {
        handleGuess(item.language);
      }}
    >
      <div ref={parentRef} className=" text-center ">
        <FlagWave
          className=" h-24 w-full sm:h-32 "
          imageUrl={`/data/${item.Alpha2Code?.toLowerCase()}/flag.svg`}
          parentRef={parentRef}
        />
        <span>{item.language}</span>
      </div>
    </RippleButton>
  );
};

export default FlagCard;
